import { reactive, readonly } from 'vue'
import apiService from '@/services/api.service'
import { WizardFlowsState } from '@/modules/wizard/types/WizardFlowsState'
import { WizardFlowsResponse } from '@/modules/wizard/types/WizardFlowsResponse'

const state = reactive<WizardFlowsState>({
  initiateFlow: null,
  preconditions: null,
  loading: false,
  error: null,
})

const setWizardData = (data: WizardFlowsResponse) => {
  state.initiateFlow = data.initiateFlow
  state.preconditions = data.preconditions
}

const fetchWizardFlows = async () => {
  state.loading = true
  state.error = null

  try {
    const { data } = await apiService.wizardFlows.get()
    setWizardData(data as WizardFlowsResponse)
  } catch (e: unknown) {
    const errorMessage =
      e instanceof Error ? e.message : 'Failed to load wizard flows'
    state.error = errorMessage
    console.error(e)
  } finally {
    state.loading = false
  }
}

const clearInitiateFlow = () => (state.initiateFlow = null)

const setInitiateFlow = (flowName: string) => (state.initiateFlow = flowName)

const setLanguageSkills = (answer: boolean): void => {
  if (state.preconditions) {
    state.preconditions.hasLanguageSkills = answer
  }
}
const setUniversityEntranceQualification = (answer: boolean): void => {
  if (state.preconditions) {
    state.preconditions.hasUniversityEntranceQualification = answer
  }
}

const setHasSufficientGermanLanguageProficiency = (answer: boolean): void => {
  if (state.preconditions) {
    state.preconditions.hasSufficientGermanLanguageProficiency = answer
  }
}

const setHasUniversityEntranceQualificationFromAbroad = (
  answer: boolean,
): void => {
  if (state.preconditions) {
    state.preconditions.hasUniversityEntranceQualificationFromAbroad = answer
  }
}

const setReadyToMove = (answer: boolean): void => {
  if (state.preconditions) {
    state.preconditions.readyToMove = answer
  }
}

export default {
  state: readonly(state),
  fetchWizardFlows,
  clearInitiateFlow,
  setInitiateFlow,
  setLanguageSkills,
  setUniversityEntranceQualification,
  setHasSufficientGermanLanguageProficiency,
  setHasUniversityEntranceQualificationFromAbroad,
  setReadyToMove,
}
